"use strict";

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

require("lazysizes/plugins/object-fit/ls.object-fit");

require("lazysizes/plugins/parent-fit/ls.parent-fit");

require("lazysizes/plugins/rias/ls.rias");

require("lazysizes/plugins/bgset/ls.bgset");

require("lazysizes");

require("lazysizes/plugins/respimg/ls.respimg");

require("../global/top-bar-notification");

require("../global/header");

require("../global/footer");

require("../global/accordions");

require("../global/product-item");

require("../global/sliders");

require("../global/subscribe");

require("../global/cart-drawer");

require("../global/toggle-buttons");

require("../global/quick-add-button");

require("../global/propagations");

require("../global/collection");

require("../global/stores");

require("../global/vto-landing");

require("../../styles/theme.scss");

require("../../styles/theme.scss.liquid");

var _themeA11y = require("@shopify/theme-a11y");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

// Common a11y fixes
// development
(0, _themeA11y.focusHash)();
(0, _themeA11y.bindInPageLinks)();

// Apply a specific class to the html element for browser support of cookies.
if (window.navigator.cookieEnabled) {
  document.documentElement.className = document.documentElement.className.replace("supports-no-cookies", "supports-cookies");
}

// $(document).on('blur', '.subscribe__field', function() {
//   console.log($(this).val());
//   if ($(this).val() != '') {
//     $(this).addClass('filled');
//   }
// });

var lat = 0;
var lng = 0;
var zoom = 13;
var icoUrl = "";
var mapOptions = {};
var map = "";
var marker = "";
var styles = [{
  featureType: "administrative",
  elementType: "all",
  stylers: [{ visibility: "on" }, { lightness: 33 }]
}, {
  featureType: "landscape",
  elementType: "all",
  stylers: [{ color: "#f2e5d4" }]
}, {
  featureType: "poi.park",
  elementType: "geometry",
  stylers: [{ color: "#c5dac6" }]
}, {
  featureType: "poi.park",
  elementType: "labels",
  stylers: [{ visibility: "on" }, { lightness: 20 }]
}, { featureType: "road", elementType: "all", stylers: [{ lightness: 20 }] }, {
  featureType: "road.highway",
  elementType: "geometry",
  stylers: [{ color: "#c5c6c6" }]
}, {
  featureType: "road.arterial",
  elementType: "geometry",
  stylers: [{ color: "#e4d7c6" }]
}, {
  featureType: "road.local",
  elementType: "geometry",
  stylers: [{ color: "#fbfaf7" }]
}, {
  featureType: "water",
  elementType: "all",
  stylers: [{ visibility: "on" }, { color: "#acbcc9" }]
}];

// initiate only if map exists
if ((0, _jquery2.default)(".map").length) {
  var map = function () {
    function initialize() {
      (0, _jquery2.default)(".map").each(function () {
        lat = (0, _jquery2.default)(this).data("lat");
        lng = (0, _jquery2.default)(this).data("lng");
        zoom = (0, _jquery2.default)(this).data("zoom");
        icoUrl = (0, _jquery2.default)(this).data("ico");
        if ((0, _jquery2.default)(this).data("styles") !== "") {
          styles = (0, _jquery2.default)(this).data("styles");
        }
        mapOptions = {
          center: new google.maps.LatLng(lat, lng),
          zoom: zoom,
          styles: styles
        };
        map = new google.maps.Map((0, _jquery2.default)(this).get(0), mapOptions);
        marker = new google.maps.Marker({
          position: map.getCenter(),
          map: map
        });

        var infowindow = new google.maps.InfoWindow({
          content: (0, _jquery2.default)(this).data("tooltip")
        });

        if (icoUrl !== "undefined") {
          marker.setIcon(icoUrl);
        }

        infowindow.open(map, marker);

        marker.addListener("click", function () {
          infowindow.open(map, marker);
        });
      });
    }

    google.maps.event.addDomListener(window, "load", initialize);

    return {
      initialize: initialize
    };
  }();

  (0, _jquery2.default)(function () {
    (0, _jquery2.default)(window).load(function () {
      map.initialize();
    });
  });
}